<template>
  <div class="modelManagement">
    <!-- 弹框 -->
    <div class="addInfo">
      <div class="infoName">模型管理</div>
      <div class="input_select">
        <div class="cloudSelect">
          <el-select v-model="value" placeholder="请选择云服务" @change="cloudChange">
            <el-option
              v-for="item in clouds"
              :key="item.id"
              :label="item.cloudName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="deviceName"><el-input v-model="deviceType" placeholder="请输入设备类型" @change="searchInput" @input="search_input"></el-input></div>
        <div class="deviceType"><el-input v-model="deviceName" placeholder="请输入设备名称" @change="searchInput" @input="search_input"></el-input></div>
        <div class="protocolType">
          <el-select v-model="protocolType" placeholder="请选择协议类型"  @change="change_protocolType" clearable>
            <el-option
            v-for="item in protocolTypeList1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="isShow">
          <el-select v-model="isShow" placeholder="请选择是否显示"  @change="change_isShow" clearable>
            <el-option
            v-for="item in isShowList1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
          </el-select>
        </div> 
      </div>
      <div class="addBtn">
        <!-- <el-button type="primary" @click="addModelManage" round>+ 新增</el-button> -->
        <el-dialog :title="dailogName" :visible.sync="dialogFormVisible1" class="addModelManage" :before-close="handleClose" v-if="dialogFormVisible1" :close-on-click-modal="false">
          <el-form
            :model="form"
            ref="subModelForm"
            :rules="formValidate"
            :label-width="formLabelWidth"
          >
            <el-form-item label="设备类型：" prop="deviceType" v-if="!edit">
              <el-input v-model="form.deviceType" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="设备名称：" prop="deviceName">
              <el-input v-model="form.deviceName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="协议类型：" prop="protocolType" v-if="!edit">
              <el-select v-model="form.protocolType" placeholder="请选择">
                <el-option
                v-for="item in protocolTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否显示：" prop="isShow">
              <el-select v-model="form.isShow" placeholder="请选择">
                <el-option
                v-for="item in isShowList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="端口：" prop="portList">
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="form.portList"
                :autosize="{ minRows: 2, maxRows: 5}">
              </el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="statusProperties">
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="form.statusProperties"
                :autosize="{ minRows: 2, maxRows: 5}">
              </el-input>
            </el-form-item>
            <el-form-item label="命令：" prop="commandProperties">
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="form.commandProperties"
                :autosize="{ minRows: 2, maxRows: 5}">
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="cancelClick('subModelForm')">取 消</el-button>
            <el-button type="primary" @click="confirmClick('subModelForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 表格 -->
    <div class="tableInfo">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :header-cell-style="{color: '#333'}"
      element-loading-background = "rgba(255, 255, 255, .5)" element-loading-text = "加载中，请稍后..." element-loading-spinner = "el-icon-loading">
        <el-table-column prop="deviceType" label="设备类型" width=""></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" width=""></el-table-column>
        <el-table-column prop="protocolType" label="协议类型" width=""></el-table-column>
        <el-table-column prop="isShow" label="是否显示" width=""></el-table-column>
        <el-table-column prop="portList" label="端口" width="" show-overflow-tooltip></el-table-column>
        <el-table-column prop="statusProperties" label="状态" width="" show-overflow-tooltip></el-table-column>
        <el-table-column prop="commandProperties" label="命令" width="" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="">
          <template slot-scope="{row}">
            <el-button type="text" size="small" @click="editModelManage(row)" class="edit">修改</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="delModelManage(row)" type="text" size="small" class="delete">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        hide-on-single-page
        :pageSize="page.pageSize"
        layout="prev, pager, next"
        :total="total"
        @current-change = "changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Utils from '../../../js/utils';
import { modelManageList,add_modelManage,del_modelManage,edit_modelManage,cloudSelectInfo } from "@/api";
import {mapState} from "vuex"
const api = require("@/api")
export default {
    data() {
      return {
        loading: false,
        loadingsubmit: false,
        confirmText: '确定',
        //下拉选择值
        value: '',
        //选择的云管理
        clouds: [],
        cloudConfigId: '',//选择的云id
        protocolTypeList: [
          {value: 1,label: '有线'},
          {value: 2,label: '无线'},
        ],
        isShowList: [
          {value: 0,label: '不显示'},
          {value: 1,label: '显示'},
        ],
        protocolTypeList1: [
          {value: null,label: '所有'},
          {value: 1,label: '有线'},
          {value: 2,label: '无线'},
        ],
        isShowList1: [
          {value: null,label: '所有'},
          {value: 0,label: '不显示'},
          {value: 1,label: '显示'},
        ],
        deviceType: "",
        deviceName: "",
        isShow: null,
        protocolType: null,
        //dialog
        dailogName: "",
        apiName: "",
        successMsg: "",
        errorMag: "",
        dialogFormVisible1: false,
        form: {
          deviceType: "",
          deviceName: "",
          protocolType: null,
          isShow: null,
          portList: "",
          statusProperties: "",
          commandProperties: "",
        },
        cloudConfigId: null,
        formValidate: {
          deviceType: [
            {required: true,message: "请输入设备类型",trigger: "blur",},
          ],
          deviceName: [
            {required:true,message:'请输入设备名称',trigger:'blur'},
            {
              validator: function(rule, value, callback) {
                if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                  callback(new Error("请输入正确的设备名称"));
                } else {
                  //校验通过
                  callback();
                }
              },
              trigger: "blur"
            }
          ],
        },
        formLabelWidth: "100px",
        //table
        tableData: [],
        //分页参数
        page: { 
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        id: null,
        add: false,
        edit: false,
        source: null,
      };
    },
    computed:{
      //映射
      ...mapState(['cloudId']),
    },
    //接收父组件数据
    // created(){
    //   var that = this;
    //   Utils.$on('demo3',function(cloudId,page) {
    //     console.log(cloudId);
    //     that.modelManageList(cloudId,page);
    //   })
    // },
    methods: {
      //下拉框数据
      cloudSelect() {
        cloudSelectInfo().then((res) => {
          // this.clouds = res.data.data;
          this.clouds=res.data.data.filter(function (item) {
　　　　　　return item.id !== 1;
          });
          this.value = this.clouds[0].id
          this.cloudConfigId = this.clouds[0].id
          this.modelManageList(this.cloudConfigId,this.page)
          res.data.data.forEach(cloud=>{
            // console.log(cloud);
          })
        });
      },
      //下拉选择信息
      cloudChange(event){
        this.cloudConfigId = event
        this.value = event
        //更新表格数据
        this.modelManageList(this.cloudConfigId,this.page)
        // this.$nextTick(this.modelManageList(this.cloudConfigId,this.page))
      },
      confirmClick(formName) {
        this.loadingsubmit = true
        this.confirmText = "提交中..."
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {}
            data = this.form
            data.cloudConfigId = this.cloudConfigId
            if(this.add){
              add_modelManage(data).then(res=>{
                if(res.data.code == '0'){
                    this.$message.success(res.data.message)
                    this.modelManageList(this.cloudConfigId,this.page)
                    this.dialogFormVisible1 = false
                    
                }else{
                    this.$message.warning(res.data.message)
                }
              })
              .catch(err=>{
                console.log(err);
                this.$message.error(res.data.message)
              })
              .finally(()=>{
                this.loadingsubmit = false
                this.confirmText = "确定"
              })
            }else if(this.edit){
              data.id = this.id
              edit_modelManage(data).then(res=>{
                if(res.data.code == '0'){
                    this.$message.success(res.data.message)
                    this.modelManageList(this.cloudConfigId,this.page)
                    this.dialogFormVisible1 = false
                    
                }else{
                    this.$message.warning(res.data.message)
                }
              })
              .catch(err=>{
                console.log(err);
                this.$message.error(res.data.message)
              })
              .finally(()=>{
                this.loadingsubmit = false
                this.confirmText = "确定"
              })
            }
          }
          else {
            this.$message.error("表单校验不通过");
            this.loadingsubmit = false
            this.confirmText = "确定"
          }
        })
      },
      cancelClick(formName){
        this.dialogFormVisible1 = false
      },
      //取消请求
      cancelQuest() {
        if (typeof this.source === 'function') {
          this.source('终止请求'); //取消请求
        }
      },
      modelManageList(id,pageList){//,deviceName,deviceType,protocolType,isShow
        this.cancelQuest()
        this.loading = true
        let data = {}
        data.cloudConfigId = id
        data.page = pageList
        data.deviceName = this.deviceName || ''
        data.deviceType = this.deviceType || ''
        data.protocolType = this.protocolType
        data.isShow = this.isShow
        modelManageList(data,this).then(res=>{
          if(res.data.code == '0'){
            this.tableData = res.data.data
            this.tableData.forEach(item=>{
              if(item.isShow === false){
                item.isShow = "不显示"
              }else if(item.isShow === true){
                item.isShow = "显示"
              }
              if(item.protocolType === 1){
                item.protocolType = "有线"
              }else if(item.protocolType === 2){
                item.protocolType = "无线"
              }
              if(item.portList === '[]'){
                item.portList = ''
              }
              if(item.commandProperties === '[]'){
                item.commandProperties = ''
              }
              if(item.statusProperties === '[]'){
                item.statusProperties = ''
              }
            })
            this.total = res.data.count
          }else{
            this.tableData = res.data.data
            this.total = 0
            this.$message.warning("模型管理"+res.data.message)
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err);
          this.tableData = []
          this.total = 0
          this.$message.error("模型管理获取数据出错或网络异常");  
          this.loading = false          
        });
      },
      addModelManage(){
          this.form = {}
          this.dialogFormVisible1 = true
          this.dailogName = "新增模型管理"
          this.add = true
          this.edit = false
          if(this.$refs['subModelForm'] !== undefined){
            this.$refs['subModelForm'].resetFields()
          } 
      },
      editModelManage(row){
          this.id = row.id
          this.form = {...row}
          if(this.form.isShow === "显示"){
            this.form.isShow = 1
          }else if(this.form.isShow === "不显示"){
            this.form.isShow = 0
          }
          if(this.form.protocolType === "有线"){
            this.form.protocolType = 1
          }else if(this.form.protocolType === "无线"){
            this.form.protocolType = 2
          }
          this.dialogFormVisible1 = true
          this.dailogName = "修改模型管理"
          this.edit = true
          this.add = false
      },
      delModelManage(row){
          this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            del_modelManage(this.cloudConfigId,row.id).then(res=>{
              if(res.data.code == "0"){
                this.modelManageList(this.cloudConfigId,this.page)
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }else{
                this.$message.warning(res.data.message)
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
          
      },
      changePage(val){
          this.page.pageNum = val
          this.modelManageList(this.cloudConfigId,this.page)
      },
      handleClose(){
        this.dialogFormVisible1 = false  
      },
      //搜索框
      searchInput(){
        this.modelManageList(this.cloudConfigId,this.page)
      },
      search_input(){
        if(this.deviceType === '' && this.deviceName === ''){
          this.modelManageList(this.cloudConfigId,this.page)
        }
      },
      change_protocolType(event){
        this.modelManageList(this.cloudConfigId,this.page)
      },
      change_isShow(event){
        this.modelManageList(this.cloudConfigId,this.page)
      }
    },
    mounted() {
      this.cloudSelect()
      //延迟调用接口
      // this.timer = setTimeout(()=>{
      //   this.modelManageList(this.cloudId,this.page)
      // },100)
    },
    //销毁定时器
    beforeDestroy() {
      clearTimeout(this.timer);
    },
};
</script>

<style scoped>
.modelManagement{
  width: 100%;
  height: 92%;
  font-family: PingFang SC;
}
.addInfo {
  width: 100%;
  height: 8%;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
}
.input_select{
  width: 90%;
  display: flex;
  justify-content: space-around;
}
.cloudSelect {
  width: 20%;
}
.deviceType, .deviceName, .protocolType, .isShow{
  width: 15%;
}

.input_select >>> .el-select{
  width: 100%;
}

.infoName{
  width: 5%;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 549;
  color: #000000;
}
.addBtn{
  width: 5%;
}
.addBtn .el-button.is-round{
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 0; */
  background: #455AF7;
  border-radius: 5px;
}
.el-button--small, .el-button--small.is-round{
    padding: 3px 3px;
}


.addModelManage{
  font-size: 16px;
}
/* 上传logo边框未设置 */

/* 弹出框 */
.addModelManage >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.addModelManage >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: 549;
  background: #fff;
  
}
.addModelManage >>> .el-dialog__body{
  padding: 15px 15px 0 15px!important;
}
.submit{
  background: #455AF7;
  border-color: #455AF7;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.addModelManage >>> .el-dialog__footer{
  padding: 0 15px 15px 15px!important;
  
}
.el-form-item{
  width: 85%;
}
.addModelManage >>> .el-select{
  width: 100%;
}

.addModelManage >>> .el-form-item__content{
  margin-left: 80px;
}
.dialog-footer{
  background: #fff;
  padding: 10px ;
}
.tableInfo{
  width: 100%;
}
.tableInfo >>> .el-table td,
.tableInfo >>> .el-table th {
  text-align: center !important;
}
.tableInfo >>> th{
  background: #F2F3F7;
}

/* 分页 */
.pagination{
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.edit{
  color: #455AF7;
}
.delete{
  color: #FB3F4E;
}

</style>


// WEBPACK FOOTER //
// src/pages/Home/modelManagement/index.vue